"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'Accordion'
});
schema.propTypes = {
  defaultExpanded: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.string).description('An array of item IDs that should be expanded on first render.'),
  expanded: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.string).description('An array of item IDs that should be expanded. If provided, controlling the Accordion must be handled externally. Overrides `defaultExpanded`.'),
  items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    PanelComponent: _reactDesc.PropTypes.element.description('A React component rendered into the accordion item panel.').isRequired,
    alwaysRender: _reactDesc.PropTypes.bool.description('If true, PanelComponent will be hidden instead of destroyed when collapsed. Useful if panel needs to maintain state.').defaultValue('false'),
    disabled: _reactDesc.PropTypes.bool.description('Disables the accordion item.').defaultValue('false'),
    icon: _reactDesc.PropTypes.element.description("An iconix icon to be rendered on the left side of the accordion item's header."),
    id: _reactDesc.PropTypes.string.description('A unique id for the accordion item. Used to track which items are expanded.').isRequired,
    title: _reactDesc.PropTypes.string.description("The text to be rendered in the accordion item's header.").isRequired
  })).description('An array of items to be rendered as an accordion.').isRequired,
  onChange: _reactDesc.PropTypes.func.description("A function called when the expanded state of one or more items changes. Called with an array of the currently expanded item's IDs."),
  size: _reactDesc.PropTypes.oneOf(['medium', 'large']).description('Sets the size of the title elements.').defaultValue('large'),
  titleHeadingLevel: _reactDesc.PropTypes.oneOf(['2', '3', '4', '5', '6']).description('Accordion item titles are rendered inside of a heading tag for accessibility purposes. This value controls the level of heading used. A value of "3" will select an `<h3>` tag.').defaultValue('3'),
  controls: _reactDesc.PropTypes.oneOf(['show', 'hide', 'disabled']).description('Sets whether to show, hide or disable expand all and collapse all buttons').defaultValue('show')
};
var _default = schema;
exports.default = _default;